import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Gift, Home } from 'lucide-react';

export default function ArtikelEidDekoIdeen() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8]">
      <section className="py-16 md:py-24 bg-[#4A5D4F]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link to="/ratgeber" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors"><ArrowLeft className="w-4 h-4" />Alle Ratgeber</Link>
          <div className="flex items-center gap-2 text-[#D4C5A9] text-sm mb-4"><Calendar className="w-4 h-4" /><span>Februar 2026</span></div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight">Eid Deko Ideen für Zuhause: Tipps & Tricks</h1>
          <p className="text-lg text-white/80 leading-relaxed">So verwandelst du dein Zuhause in eine festliche Eid-Oase.</p>
        </div>
      </section>
      <article className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12 prose prose-lg max-w-none">
          <p className="text-xl text-[#2C332E] leading-relaxed mb-8">Die richtige Dekoration schafft Eid-Stimmung und macht das Fest zu etwas Besonderem. Von Lichterketten bis Tischdeko – hier findest du alle Ideen für ein festlich geschmücktes Zuhause.</p>

          <section className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#D4C5A9]/30 flex items-center justify-center"><Home className="w-6 h-6 text-[#4A5D4F]" /></div>
              <h2 className="font-serif text-2xl font-medium text-[#2C332E]">Eingangsbereich</h2>
            </div>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Eid Mubarak Türkranz</h4>
                <p className="text-sm text-[#4B5563]">Ein Kranz mit Mond, Sternen und "Eid Mubarak"-Schriftzug begrüßt Gäste festlich.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Willkommens-Banner</h4>
                <p className="text-sm text-[#4B5563]">Stoff- oder Papierbanner an der Tür oder im Flur mit islamischen Grüßen.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Laternen & Lichter</h4>
                <p className="text-sm text-[#4B5563]">Orientalische Laternen mit LED-Kerzen links und rechts der Tür.</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Wohnzimmer</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🌙 Mond & Stern Girlanden</h4>
                <p className="text-sm text-[#4B5563]">Gold- oder silberfarbene Girlanden an Fenstern, Türrahmen oder der Decke aufhängen.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">✨ Lichterketten</h4>
                <p className="text-sm text-[#4B5563]">Warme Lichterketten um Regale, Fenster oder Pflanzen drapieren.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🎈 Luftballons</h4>
                <p className="text-sm text-[#4B5563]">"Eid Mubarak"-Folienballons und goldene Latex-Ballons als Dekobündel.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🕯️ Kerzen & Duft</h4>
                <p className="text-sm text-[#4B5563]">Duftkerzen mit orientalischen Noten (Oud, Rose, Amber) schaffen Atmosphäre.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🖼️ Islamische Kunst</h4>
                <p className="text-sm text-[#4B5563]">Kalligraphie-Drucke oder Wandbehänge mit Koranversen oder "Eid Mubarak".</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Esstisch & Küche</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Festliche Tischdecke</h4>
                <p className="text-sm text-[#4B5563]">Weiß, Gold oder Grün – passend zur Farbpalette. Stoffservietten mit Mondringen.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Mittelstück / Centerpiece</h4>
                <p className="text-sm text-[#4B5563]">Laterne, Blumen oder eine Schale mit Datteln als Tischmittelpunkt.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Platzkarten</h4>
                <p className="text-sm text-[#4B5563]">Für größere Feiern: Personalisierte Karten mit islamischen Designs.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Süßigkeiten-Display</h4>
                <p className="text-sm text-[#4B5563]">Etagere mit Baklava, Datteln und Süßigkeiten als Blickfang.</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Farbpaletten für Eid</h2>
            <div className="grid sm:grid-cols-3 gap-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5 text-center">
                <div className="w-12 h-12 rounded-full bg-[#D4AF37] mx-auto mb-3"></div>
                <h4 className="font-medium text-[#2C332E]">Gold & Weiß</h4>
                <p className="text-sm text-[#4B5563]">Elegant & klassisch</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5 text-center">
                <div className="w-12 h-12 rounded-full bg-[#4A5D4F] mx-auto mb-3"></div>
                <h4 className="font-medium text-[#2C332E]">Grün & Gold</h4>
                <p className="text-sm text-[#4B5563]">Traditionell islamisch</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5 text-center">
                <div className="w-12 h-12 rounded-full bg-[#E8D5C4] mx-auto mb-3"></div>
                <h4 className="font-medium text-[#2C332E]">Pastelltöne</h4>
                <p className="text-sm text-[#4B5563]">Modern & soft</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Wo kaufen?</h2>
            <div className="bg-[#4A5D4F]/10 rounded-xl p-6">
              <ul className="text-[#4B5563] space-y-2">
                <li><strong>Online:</strong> Amazon, Etsy, islamische Online-Shops</li>
                <li><strong>Lokal:</strong> Action, Tedi, Nanu-Nana (basics), orientalische Geschäfte</li>
                <li><strong>DIY:</strong> Viele Dekorationen lassen sich günstig selbst basteln!</li>
              </ul>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Fazit</h2>
            <p className="text-[#4B5563] leading-relaxed mb-4">Mit der richtigen Dekoration wird dein Zuhause zur Eid-Oase. Ob minimalistisch oder opulent – wichtig ist, dass es sich für dich und deine Familie festlich anfühlt!</p>
            <p className="text-xl text-[#4A5D4F] font-medium">Eid Mubarak! 🌙</p>
          </section>

          <div className="bg-[#F5F5F0] rounded-2xl p-6 mb-8">
            <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-4">Weitere Artikel</h3>
            <ul className="space-y-2">
              <li><Link to="/ratgeber/diy-eid-tischdeko" className="text-[#4A5D4F] hover:underline">→ DIY Ramadan & Eid Tischdeko</Link></li>
              <li><Link to="/ratgeber/minimalistische-eid-deko" className="text-[#4A5D4F] hover:underline">→ Minimalistische Eid Dekoration</Link></li>
            </ul>
          </div>

          <div className="bg-[#4A5D4F] rounded-2xl p-8 text-center">
            <h3 className="font-serif text-2xl font-medium text-white mb-4">Geschenke entdecken</h3>
            <Link to="/geschenke" className="inline-flex items-center gap-2 bg-white text-[#4A5D4F] px-8 py-3 rounded-full font-medium hover:bg-[#D4C5A9] transition-colors">Jetzt stöbern<Gift className="w-5 h-5" /></Link>
          </div>
        </div>
      </article>
    </main>
  );
}
